import { queryOptions } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { Ref } from "vue";
import type { PowerUpServiceResponseBody } from "@vendata/power-up-spec";

interface MineRepairsQueryOptions {
  status?: Ref<"open" | "closed" | undefined>;
}

export const mineRepairsQuery = (options: MineRepairsQueryOptions = {}) => {
  return queryOptions({
    queryKey: ["repairs", "mine", options.status],
    queryFn: async (): Promise<
      PowerUpServiceResponseBody["mineRepairs"][200]
    > =>
      handleClientMethod(
        getClient().GET("/repairs/mine", {
          params: {
            query: {
              status: options.status?.value,
            },
          },
        }),
      ),
  });
};
